import React from "react";
import logo from "assets/images/occ-logo.png";
import { useAppSelector } from "common/hooks/storeHooks";
import { currentOrgLogo } from "common/selectors/org.selectors";
import { getUrl } from "common/records/Image";
import { Spinner } from "common/components/Spinner";
import { RootState } from "common/reducers";
import { loading } from "common/selectors/idsManagement.selectors";

export interface BaseHeaderProps {}

export const BaseHeader: React.FC<BaseHeaderProps> = () => {
  //Selectors
  const orgLogo = useAppSelector(currentOrgLogo);
  const customerOrgLoading = (state: RootState) => loading(state, { modelName: "customerOrg" });
  return (
    <>
      <Spinner loadingSelector={customerOrgLoading} />
      <header className="border-b border-b-secondary-100 py-lg px-xl">
        <div className="w-[109.08px] h-[42.71px] flex items-center">
          <img
            src={orgLogo ? getUrl(orgLogo, "small") : logo}
            alt="Org Logo"
            className="object-contain max-w-full max-h-full"
          />
        </div>
      </header>
    </>
  );
};
